import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  TranslateModule,
  TranslateService,
  TranslatePipe,
} from '@ngx-translate/core';
import { BaseComponent } from '../../base.component';
import { SchoolApiService } from '../../../Services/schoolApi.service';

@Component({
  selector: 'app-mediacenter',
  standalone: true,
  imports: [TranslateModule, RouterOutlet],
  providers: [TranslateService, TranslatePipe],
  templateUrl: './mediacenter.component.html',
  styleUrl: './mediacenter.component.css',
})
export class MediaCenterComponent extends BaseComponent {
  MEDIA_DESCRIPTION = {
    PRESS_MEDIA: {
      en: '"Media are open doors to the world, allowing ideas to circulate and cultures to meet.", Jean Cocteau, French writer, poet, and artist (1889-1963).',
      fr: '"Les médias sont des portes ouvertes sur le monde, permettant aux idées de circuler et aux cultures de se rencontrer.", Jean Cocteau, écrivain, poète et artiste français (1889-1963).',
      ar: `
"وسائل الإعلام هي أبواب مفتوحة على العالم، تتيح للأفكار أن تنتشر والثقافات أن تلتقي." — جان كوكتو، كاتب وشاعر وفنان فرنسي (1889-1963)
`,
    },
    RADIO: {
      en: `"Radio is a way of communicating the invisible, of making audible what is only sensation and thought."
Marcel Proust, French writer (1871-1922).
"`,
      fr: `"La radio est une manière de communiquer l'invisible, de rendre audible ce qui n'est que sensation et pensée.", Marcel Proust, écrivain français (1871-1922).`,
      ar: `
"الراديو هو وسيلة للتواصل مع ما هو غير مرئي، وجعل ما هو مجرد شعور وفكر مسموعاً" ، مارسيل بروست، كاتب فرنسي ، (1871-1922)
`,
    },
    ARCHIVE: {
      en: '"Archives are not documents of the past; they are the power that has structured the present.",  Michel Foucault, French philosopher (1926-1984)',
      fr: '"Les archives ne sont pas simplement des documents du passé, elles sont les indices d’un pouvoir qui a structuré le présent.", Michel Foucault, philosophe français (1926-1984)',
      ar: `
"الأرشيف ليس مجرد وثائق عن الماضي، بل هو القوة الذي شكل الحاضر."، ميشيل فوكو، فيلسوف فرنسي (1926-1984)
`,
    },
  };

  constructor(override readonly schoolApiService: SchoolApiService) {
    super(schoolApiService);
  }
}
